<template>
  <main class="organism-create-new-ticket">
    <section name="header">
      <label class="header__container header__text--topic"
        >Create New Ticket</label
      >
    </section>

    <!-- Customer Start-->
    <section name="customer">
      <div class="customer__container">
        <div class="customer__name w-100 d-flex">
          <label class="text--header">Customer Name</label>
          <label class="text--body">{{ customer.name }}</label>
        </div>
        <div class="customer__email w-100 d-flex">
          <label class="text--header">Email Addresses</label>
          <label class="text--body">{{ customer.email }}</label>
        </div>
        <div class="customer__phone w-100 d-flex">
          <label class="text--header">Phone Numbers</label>
          <label class="text--body">{{ customer.phone }}</label>
        </div>
        <div class="customer__idc w-100 d-flex">
          <label class="text--header">{{ contractIdLabel }}</label>
          <label class="text--body">{{ customer.idcId }}</label>
        </div>
        <div class="customer__site w-100 d-flex">
          <label class="text--header">Site</label>
          <label class="text--body">{{ customer.site }}</label>
        </div>
        <div class="customer__location w-100 d-flex">
          <label class="text--header">Location</label>
          <span class="text--body text-show-new-line">{{
            customer.locations
          }}</span>
        </div>
      </div>
    </section>
    <!-- customer End-->

    <!-- Ticket Start-->
    <section name="ticket">
      <div class="ticket__container">
        <div class="ticket__topic input-container">
          <atom-select
            v-model="ticket.topic"
            title="Topic"
            placeholder="Select Topic"
            label="name"
            :isAsterisk="true"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isClearable="false"
            :isSearchable="false"
            :option="topicList"
            :isError="isErrorTicket.topic"
            :errorMessage="errorMessageTicket.topic"
          ></atom-select>
        </div>
        <div class="ticket__subject input-container">
          <atom-input
            v-model="ticket.subject"
            title="Topic Subject"
            placeholder="Subject"
            :isAsterisk="true"
            :isDisable="false"
            :isError="isErrorTicket.subject"
            :errorMessage="errorMessageTicket.subject"
          ></atom-input>
        </div>
        <div class="ticket__detail input-container">
          <atom-text-area
            v-model="ticket.detail"
            title="Topic Detail"
            placeholder="Detail"
            :isAsterisk="true"
            :isDisable="false"
            :isError="isErrorTicket.detail"
            :errorMessage="errorMessageTicket.detail"
            :isResizable="true"
          ></atom-text-area>
        </div>
        <div class="ticket__attachments">
          <atom-file-attachment-input
            id="createExternalTicketAttachment"
            title="Attachments (Max. 25Mb)"
            @onUpdateFile="onUpdateTicketAttachment"
          ></atom-file-attachment-input>
        </div>
      </div>
    </section>
    <!-- Ticket End-->

    <!-- Button Start-->
    <section name="button">
      <div class="button__container w-100">
        <div class="button__create">
          <atom-button
            buttonId="button__create"
            :isDisable="isDisableButton"
            @click="onClickCreateNewTicket"
            >Create Ticket</atom-button
          >
        </div>
        <div class="button__cancel">
          <atom-button
            buttonId="button__cancel"
            buttonStyle="border"
            buttonColor="secondary"
            @click="onClickCancel"
            >Cancel</atom-button
          >
        </div>
      </div>
    </section>
    <!-- Button End-->

    <!-- Modal Start-->
    <section name="modal">
      <molecule-modal-dialog
        modalId="create-ticket__confirm-create"
        :isTextCenter="true"
        :textTitle="`Do you want to\ncreate “${ticket.subject}” ?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmCreate"
      ></molecule-modal-dialog>
      <molecule-modal-dialog
        modalId="create-ticket__confirm-cancel"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmCancel"
      ></molecule-modal-dialog>
    </section>
    <!-- Modal End-->
  </main>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import AtomFileAttachmentInput from "@/components/atoms/AtomFileAttachmentInput.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import { mapGetters } from "vuex"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  name: "OrganismTicketCreateNewTicket",
  components: {
    AtomSelect,
    AtomInput,
    AtomTextArea,
    AtomFileAttachmentInput,
    AtomButton,
    MoleculeModalDialog,
  },
  props: {
    customerData: {
      type: Object,
      required: true,
    },
    topicList: {
      type: Array,
      required: true,
    },
    ticketData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  mixins: [mixins, mixinsValidator],
  emits: ["selectedTopicId", "createTicket"],
  data() {
    return {
      // validate
      isValidate: false,
      isError: false,

      // modal
      modalId: null,

      // customer
      customer: {
        idcId: null,
        name: null,
        email: null,
        phone: null,
      },

      // ticket
      selectTopicId: null,
      ticket: {
        topic: null,
        subject: null,
        detail: null,
        attachments: null,
      },
      isErrorTicket: {
        topic: false,
        subject: false,
        detail: false,
      },
      errorMessageTicket: {
        topic: null,
        subject: null,
        detail: null,
      },
    }
  },
  computed: {
    ...mapGetters("appPermission", ["getCustomerSitePermissions"]),
    isDisableButton() {
      return this.isValidate && this.isError
    },
  },
  watch: {
    ticket: {
      deep: true,
      handler() {
        if (this.ticket.topic?.id) this.getTicketData()
        if (this.isValidate) this.validateTicket()
      },
    },

    ticketData: {
      deep: true,
      handler() {
        if (this.ticketData) {
          this.ticket = {
            topic: this.ticketData.topic,
            subject: this.ticketData.subject,
            detail: this.ticketData.detail,
          }
        }
        if (this.isValidate) this.validate()
      },
    },
  },

  mounted() {
    this.customer = this.customerData
  },

  methods: {
    // get ticket data
    getTicketData() {
      if (!this.selectTopicId || this.selectTopicId !== this.ticket.topic.id) {
        this.selectTopicId = this.ticket.topic.id
        this.$emit("selectedTopicId", this.selectTopicId)
      }
    },

    // click button
    onClickCreateNewTicket() {
      this.isValidate = true
      this.validateTicket()
      if (this.isValidate && !this.isError)
        this.openModal("create-ticket__confirm-create")
    },

    clickConfirmCreate() {
      const siteId = this.getCustomerSitePermissions?.find(
        (x) => x !== undefined
      )
      const createTicket = {
        topicId: this.ticket.topic.id,
        ticketSubject: this.ticket.subject,
        ticketDetail: this.ticket.detail,
        priority: "MEDIUM",
        contractId: Number(this.customer.idcId).toString(),
        contractCustomerName: this.customer.name,
        contractEmails: this.getCustomerEmail(),
        contractPhones: this.customer.phone,
        siteId,
      }
      const uploadAttachment = this.ticket.attachments
      this.$emit("createTicket", createTicket, uploadAttachment)
      this.closeModal()
    },

    getCustomerEmail() {
      return this.customer.email
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email.length > 0)
        .join(",")
    },

    onClickCancel() {
      this.openModal("create-ticket__confirm-cancel")
    },

    clickConfirmCancel() {
      this.$router.push("/web-portal/ticket")
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    // validate
    validateTicket() {
      // topic
      if (!this.ticket.topic) {
        this.isErrorTicket.topic = true
        this.errorMessageTicket.topic = "Please select topic"
      } else {
        this.isErrorTicket.topic = false
        this.errorMessageTicket.topic = null
      }
      // subject
      if (!this.ticket.subject || this.isEmptyString(this.ticket.subject)) {
        this.isErrorTicket.subject = true
        this.errorMessageTicket.subject = "Please enter subject"
      } else {
        this.isErrorTicket.subject = false
        this.errorMessageTicket.subject = null
      }
      // detail
      if (!this.ticket.detail || this.isEmptyString(this.ticket.detail)) {
        this.isErrorTicket.detail = true
        this.errorMessageTicket.detail = "Please enter detail"
      } else {
        this.isErrorTicket.detail = false
        this.errorMessageTicket.detail = null
      }
      this.isError =
        this.isErrorTicket.topic ||
        this.isErrorTicket.subject ||
        this.isErrorTicket.detail
    },

    onUpdateTicketAttachment(fileList) {
      this.ticket.attachments = fileList
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-create-new-ticket {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}

section[name="header"] {
  .header__container {
    margin: 21px;
  }

  .header__text--topic {
    font-weight: 500;
    font-size: 18px;
  }
}

section[name="customer"] {
  .customer__container {
    padding: 0 21px 21px 21px;
  }

  .customer__email,
  .customer__phone,
  .customer__idc,
  .customer__site,
  .customer__location {
    margin: 1rem 0 0 0;
  }
}

section[name="ticket"] {
  .ticket__container {
    padding: 0 21px 21px 21px;
  }

  .ticket__subject,
  .ticket__detail {
    margin: 1rem 0 0 0;
  }

  .ticket__attachments {
    margin: 1rem 0 0 0;
  }
}

section[name="button"] {
  .button__container {
    display: flex;
    justify-content: flex-end;
    padding: 21px 21px 42px 21px;
  }

  .button__cancel {
    margin: 0 0 0 16px;
  }
}

.text--header {
  margin: 0 1rem 0 0;
  width: 100px;
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 600;
}

.text--body {
  margin: 0;
  width: calc(100% - 100px);
  color: #5e5873;
  font-size: 14px;
}

.input-container {
  width: 100%;
}

.input-container-small {
  width: 75px;
}

@media screen and (min-width: 768px) {
  .text--header {
    width: 170px;
  }

  .text--body {
    width: calc(100% - 170px);
  }

  .input-container {
    width: 325px;
  }
}

@media screen and (min-width: 992px) {
}

@media screen and (min-width: 1200px) {
}
</style>
